import React, { useState , useEffect, useContext} from 'react';



import Logo from '../../images/logo.png';
import Naked from '../../images/naked.png';
import NigeriaLogo from '../../images/nigerialogo.png';
import Bvn from  '../../images/bvn.jpg';
import LoadingImg from '../../images/loading.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faInfo, faDashboard, faBookBookmark, faCalendar,
     faPuzzlePiece , faShieldAlt, faDiceOne, faBahtSign, faChartBar, faTools
    , faBell, faChevronDown, faArrowUp,
    faCloud,
    faPhone} from '@fortawesome/free-solid-svg-icons';
import HomeImg from '../../images/homebody.png';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ShareContext } from '../../context/sharecontext';

import IdLayout from '../../components/_layout';
import * as Constants from '../../Constants';

//import cacData from '../../data/cac.json';
import IdInput from '../../components/idInput';
import IdSelect from '../../components/idSelect';


function Setting() {
    const { profile,raw,activeType, token } = useContext(ShareContext);
    const navigate = useNavigate();
    const [staySigned, setStaySigned] = useState(false)
    const [view, setView] =useState('profile');
    const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);
    const [company, setCompany] =useState({});
    const [subview, setSubView] =useState('notcom'); //notcom is a state where you switch to 'com' so you can have company info, or 'api' already company details with API key
    const [plans, setPlans]=useState([{value:1,text:'super Bundle'}])
    const [credentials, setCredentials]=useState([]);
    const [users, setUsers]= useState([]);
    const [isadmin, setIsAdmin]=useState(false);
    const [iscompany, setIsCompany] = useState(false);
    const [plan, setPlan]=useState({});
    const [userType, setUserType]=useState('');
    const [payments, setPayments] = useState([]);
    const [verificationPricing, setVerificationPricing]=useState({unitCost:1});
   
  
   // const {type} = useParams(); 
    
    //const data=bvnData.ResponseData;

  //console.log(cacData);

    const isPlatformAdmin = userType=='superadmin' || userType=='Admin';

    useEffect(() => {
       // Constants.seo('','');
        Constants.seo({title:'IdVerify Settings',metaDescription:''});
        if(profile!=null){
            LoadSetting();
            LoadPlans();
        }

    }, [profile]);

    useEffect(() => {
        if (isPlatformAdmin) {
            LoadVerificationPricing();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userType]);

    const onPrint=()=>{
        window.print();
    }

    const onSaveCompany=async(e)=>{
        e.preventDefault(); 
  
          setLoading(true);
          
          try {
            var v={...company, status:'pending',currentPlanId:1, adminUserId:profile.id};
            const resp = await fetch(`${Constants.rooturl}/customer/company`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                //setGazettes(data.gazettes);
                
               setCompany({...company, id:data.id}) ;
               setCredentials([data.cre]);
  
              
            }else if(data.code==-10){
              navigate('/login')
            }else {   
              setErr('Either same company name already exist for another agent');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }

    const LoadSetting= async()=>{ //doctype=upline always this one
        //for account registration DocumentView
        const url=`${Constants.rooturl}/customer/settings`
    
        console.log(`the calling url ${url}`);
        try {
            setLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
           console.log(data);
            if(data.code==0 ){
              // navigate(`/AffidavitDocuments/${data.docId}/edit/${data.uplineId}`)

              //if(data.iscompany){
                setCompany(data.com);
              setCredentials(data.credentials);
              setUsers(data.users);
              setIsCompany(data.iscompany);
              setIsAdmin(data.isadmin);
              setUserType(data.userType);
              setPayments(data.payments);
              //}
              
             
            }else if(data.code==-10){
              navigate('/login')
            }
            else{
               // setAlert({open:true, title:'Payment Status', subtitle:data.status, code:data.code, data, onOk})
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }

    const onPlanChange = (e) => {
      setPlan({...plan, [e.target.name]: e.target.value})
    }

    const onSavePlan=async(e)=>{
      e.preventDefault(); 

        setLoading(true);
        
        try {
          var v={...plan, createdBy:profile.id};
          const resp = await fetch(`${Constants.rooturl}/customer/plan`, {
            method: 'POST',
            body:JSON.stringify(v) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': token,
            },
          });
          
          const data = await resp.json();
          setLoading(false);
          console.log(data);
          if (data.code === 0) {
              //setGazettes(data.gazettes);
              
            setPlan({...plan, id:data.id}) ;
            setPlans([...plans,{...plan, id:data.id}]); //add the extra
            setCredentials([data.cre]);

            
          }else {   
            setErr('username/password not correct');
          }
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
        // onMove();
        }

      }
   
    const LoadPlans = () => {


      fetch(`${Constants.rooturl}/customer/plans`,{
          method: 'GET',
          headers: {
              "Content-Type": "application/json",
              "Authorization": token
          },
      })
      .then((resp) => resp.json())
      .then((data) => {
          setPlans(data);
        
      }).catch((error) => {
          console.log(error)
          setLoading(false)
      })
    
    
      }

    const LoadVerificationPricing = async () => {
        try {
            const resp = await fetch(`${Constants.rooturl}/VerificationAdmin/pricing`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
            });
            const data = await resp.json();
            if (data.code === 0) {
                setVerificationPricing(data.pricing);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onSaveVerificationPricing = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const resp = await fetch(`${Constants.rooturl}/VerificationAdmin/pricing`, {
                method: 'POST',
                body: JSON.stringify({ unitCost: verificationPricing.unitCost }),
                headers: {
                    'Content-Type': 'application/json, text/plain',
                    'Authorization': token,
                },
            });
            const data = await resp.json();
            setLoading(false);
            if (data.code === 0) {
                setVerificationPricing(data.pricing);
            } else {
                setErr(data.status || 'Could not save the unit price.');
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
        }
    };

  return (

   <IdLayout active={activeType} profile={profile}>
    <div style={{display:'flex',  flex:1,padding:8, flexDirection:'column'}}>
            <div style={{display:'flex', backgroundColor:'white', flex:1, flexDirection:'column'}}>
        
        <div  className='idtab'>
            <div className={`tabitem ${view=='profile'?'tabactive':''}`} onClick={()=>setView('profile')}>Profile</div>
            <div className={`tabitem ${view=='api'?'tabactive':''}`} onClick={()=>setView('api')}> API</div>
            <div className={`tabitem ${view=='payment'?'tabactive':''}`} onClick={()=>setView('payment')}> Payment History</div>
          {userType=='superadmin' && <>
            <div className={`tabitem ${view=='plan'?'tabactive':''}`} onClick={()=>setView('plan')}> Plan</div>
          </>}
          {isPlatformAdmin && <>
            <div className={`tabitem ${view=='verificationpricing'?'tabactive':''}`} onClick={()=>setView('verificationpricing')}> Verification Pricing</div>
          </>}
        </div>
           
{view=='profile' && <div>
    <div className='ninsearch'>
      <div className='cdiv'>
        <div><span>First Name:</span> <span>{profile?.firstName}</span> </div>
        <div><span>Last Name:</span> <span>{profile?.lastName}</span> </div>
        <div><span>Email:</span> <span>{profile?.email}</span> </div>
        <div><span>Wallet Balance:</span> <span>{profile?.unitBalance}</span> </div>
        <button>Change Password</button>
      </div>
        
    </div>
    </div>}

 {view=='api' && <div>
              {!iscompany && <div>
                    <p>This is not a company/agent account, whould you want to make it so</p>
                    <button onClick={()=> setIsCompany(true)}>Change account to Agent/Company</button>
                </div>}  
             {iscompany && <div>
                    <p>You do not have any setup Agent/Company Account</p>
                    <form onSubmit={onSaveCompany}> 
                        <h3>Company/Agent Details</h3>
                        <IdInput label='Company/Agent Name' value={company?.name} onChange={(e)=> setCompany({...company, name:e.target.value})} />
                        <IdInput label='Address' value={company?.address} onChange={(e)=> setCompany({...company, address:e.target.value})}/>
                        <IdInput label ='Contact Person Email' value={company?.email} onChange={(e)=> setCompany({...company, email:e.target.value})} />
                        <IdInput label='Contact Person Phone' value={company?.phone} type='number' onChange={(e)=> setCompany({...company, phone:e.target.value})} />
                        {loading && <div  style={{display:'flex', justifyContent:'center', marginBottom:16, flexDirection:'column'}}>
                                    <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
                                    <span style={{ marginLeft:'auto', marginRight:'auto'}}>Loading...</span>
                                    </div>}  
                        {!loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                                    
                            <button className='greenbutton' style={{width:'100%'}} type="submit">Save Company Details</button>
                                </div>} 
                    </form> 
                </div>}   

            {credentials.length>0 &&  <div>

                {
                      credentials?.length>0 &&  credentials?.map((cre, id) => {
                          return (
                            <div key={id}>
                    <p>Your API Key Details <span style={{color:cre?.keyType=='demo'? 'red':'green'}}>{cre?.keyType}</span></p>
                    <div>
                        <p><span>Private Key: </span> <span>{cre.privateKey}</span> </p><button>Generate New</button>
                    </div>
                    </div>
                          )
                        })
                      }
                   
                    
                </div>}    
                
    </div>} 

    {view=='payment' && <div>
    payment History

   <table className='specialtable'> 
    <tr><th>Reference ID</th><th>Amount</th><th>Units</th><th>Date</th><th>Plan</th></tr>
    {payments?.map((pay, idx) =>{return (
         <tr>
            <td>{pay.payRef}</td>
            <td>{pay.amount}</td>
            <td>{pay.balanceUnit}</td>
            <td>{pay.createDate}</td>
            <td>{pay.planIdApplied}</td>
         </tr>
     )})}
   </table>
    </div>}   
    {userType=='superadmin' && <>
        {view=='plan' &&
        <div>
          <div>
            <form onSubmit={onSavePlan}>
              <IdInput label='Plan Name' value={plan.name} name="name" onChange={onPlanChange} />
            <IdInput label='Unit cost' value={plan.costPerUnit}  name="costPerUnit" onChange={onPlanChange}/>
            <IdInput label ='Min Unit' value={plan.minUnit} name="minUnit"  onChange={onPlanChange}/>
            <div style={{display:'flex'}}>
              <button type='submit'  className='greenbutton middle'> Save</button>
            </div>
            
            </form>
            
          </div>

          <div>
            <table className='specialtable'>
              <tr>
                <th>Name</th>
                <th>Cost Per Unit</th>
                <th>Min Unit</th>
                <th>Action</th>
              </tr>
              {plans.map((item, idx) =>{return (

                    <tr key={idx} >
                      <td>{item.name}</td>
                      <td>{item.costPerUnit}</td>
                      <td>{item.minUnit}</td>
                      <td><Link to="">Edit</Link></td>
                    </tr>
                  )})}
              
              
            </table>
          </div>

          </div>}
    </>}
    {isPlatformAdmin && <>
        {view=='verificationpricing' &&
        <div>
          <p>How many units a single completed Face Match + Liveness verification costs, across every bank on the platform.</p>
          <form onSubmit={onSaveVerificationPricing}>
            <IdInput label='Unit Cost' type='number' value={verificationPricing.unitCost} name="unitCost" onChange={(e)=> setVerificationPricing({...verificationPricing, unitCost:e.target.value})} />
            <div style={{display:'flex'}}>
              <button type='submit' className='greenbutton middle'> Save</button>
            </div>
          </form>
        </div>}
    </>}

   </div>

<div>

</div>

    </div>
   </IdLayout>
  )
}

export default Setting